'use strict';

import 'signalr';
import SignalRHub from 'angular-signalr-hub';
import m42Dashboards from '@dwp/dashboards';
import 'angular-sortable-view';
import componentsModule from '../PandoraComponents';

mx.SolutionBuilderAgent = mx.SolutionBuilderAgent || {};

export default angular.module('mx.SolutionBuilderAgent', [componentsModule, SignalRHub, m42Dashboards, 'angular-sortable-view']).name;
